export default {
  methods: {
    isValidValue(value, is_null_valid) {
      if (is_null_valid && (value == null || value == undefined)) return true
      return value != null && value != undefined && (value == 0 || value != '') && !isNaN(value)
    },
    parseValue(value, can_be_null) {
      if (value == null && can_be_null) return null
      else if (!this.isValidValue(value)) return 0
      else if (typeof value == 'number') return value

      let result = 0
      if (value.toString().indexOf('.') !== -1) result = parseFloat(value)
      else result = parseInt(value)

      return isNaN(result) ? 0 : result
    },
  }
}



// WEBPACK FOOTER //
// app/javascript/components/mixins/charts/helpers.js